/**
 * @Copyright 2014-2019 DataVoke, Inc. All rights reserved.
 */

'use strict';

import {
    applyUnknownProperties,
    ClientProperties,
    EntityBase,
    EntityDefinitionBase
} from "./entitybase";
import {EntityTypes} from "../utils/dvtypes";
import {tempID} from "../utils/tools";

class CategoryDefinition extends EntityDefinitionBase {
    /**
     * Create a new Category Definition instance
     * @param {Object|Null} [defaults = {}] - (OPTIONAL) Default object (transmitted definition object?) to use for properties
     */
    constructor (defaults = {}) {
        if (defaults == null) {
            // this can happen if "null" is actually passed as "defaults"
            defaults = {};
        }

        super(defaults);

        /**
         * Name for the category definition
         * @type {string}
         */
        this.Name = this.Name || "New Category";

        // allow for any entity definition properties not known by the class
        applyUnknownProperties(this, defaults);
    }
}

export class CategoryEntity extends EntityBase {
    /**
     * Create a new Category entity instance
     * @param {Object|Null} [defaults = {}] - (OPTIONAL) Default object (transmitted definition object?) to use for properties
     * @param {number} [defaults.CategoryID] - Optional category ID number for this category entity
     * @param {string} [defaults.RecordTypeUID] - Optional UID of the record type entity for this category entity
     * @param {Object} [defaults.Definition] - Default object for properties of the category entity definition
     */
    constructor (defaults = {}) {
        if (defaults == null) {
            // this can happen if "null" is actually passed as "defaults"
            defaults = {};
        }

        // ensure that the definition property of the defaults is an object.
        if (defaults.Definition && typeof defaults.Definition === 'string') {
            defaults.Definition = JSON.parse(defaults.Definition);
        }

        super(defaults);

        /**
         * Name of the category entity
         * @type {string}
         */
        this.Name = this.Name || "New_Category";

        /**
         * Retrieve or generate the property ID value for this category entity
         * @type {number}
         */
        this.CategoryID = defaults.CategoryID || tempID();

        /**
         * The UID value of the record type entity this category entity belongs to
         * @type {string|null}
         */
        this.RecordTypeUID = defaults.RecordTypeUID || null;

        /**
         * Set the definition for this category entity
         * @type {CategoryDefinition}
         */
        this.Definition = new CategoryDefinition(defaults.Definition);

        /**
         * Set the client properties for this entity type
         * @type {ClientProperties}
         */
        this.clientProperties = new ClientProperties(EntityTypes.Category);
    }
}
